import { setSelectorDefaults, setSelectors } from "../reducers/actions";
import { getSelectorDefaults, getSelectors } from "../reducers/selectors";
import { isStubSelector } from "./requestDefaults";
/**
 * Update selector defaults and refetch the current configuration
 * @param selectorOptions
 * @param options
 * @returns
 */
export function updateSelectorDefaults(selectorOptions) {
    return (dispatch, getState) => {
        const rootState = getState();
        const defaults = getSelectorDefaults(rootState);
        const selectors = getSelectors(rootState);
        // update selector settings, keep stubs and paths
        const nextSelectors = selectors.map((selector) => isStubSelector(selector)
            ? selector
            : Object.assign(Object.assign(Object.assign({}, selector), selectorOptions), { path: selector.path }));
        // update defaults
        dispatch(setSelectorDefaults(Object.assign(Object.assign({}, defaults), selectorOptions)));
        // update all selectors
        dispatch(setSelectors(nextSelectors));
    };
}
//# sourceMappingURL=updateSelectorDefaults.js.map